<template>
  <ChartLoadingContainer :loading="loading">
    <ChartJSComponent
      class="full-width full-height"
      :datasets="datasets"
      :labels="labels"
      :options="options"
      :type="chartType"
    />
  </ChartLoadingContainer>
</template>

<script>
import ChartJSComponent from '@components/chart/ChartJSComponent.vue'
import ChartLoadingContainer from '@components/chart/ChartLoadingContainer.vue'
import sdk from '@service/auth-sdk'
import { getChartColor } from '@utils'
export default {
  components: { ChartJSComponent, ChartLoadingContainer },
  props: {
    params: { type: Object, default: () => ({ type: '7days' }) },
    type: { type: String, default: 'user' },
  },
  data: () => ({
    loading: true,
    chartType: 'line',
    labels: [],
    datasets: [
      {
        label: 'Lần đăng nhập',
        data: [],
        lineTension: 0.4,
        fill: false,
        borderColor: getChartColor(0),
        backgroundColor: getChartColor(0),
      },
    ],
    options: {
      title: {
        display: false,
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: false,
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        ],
      },
    },
  }),
  computed: {},
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/user/frequency-login',
        params: { data_type: this.type, ...this.params },
      })
      this.datasets[0].data = []
      this.labels = []
      this.loading = false
      let data = res.data
      for (let i in data) {
        let item = data[i]
        this.datasets[0].data.push(item.count)
        this.labels.push(item.date)
      }
    },
  },
}
</script>

<style scoped></style>
